import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alert-cell" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "alert-body__title" }
const _hoisted_4 = { class: "alert-body__title__main" }
const _hoisted_5 = { class: "alert-body__title__main__text alert-body__title__text--alert" }
const _hoisted_6 = { class: "alert-body__title__sub" }
const _hoisted_7 = { class: "alert-body__title__sub__text alert-body__title__text--alert" }
const _hoisted_8 = { class: "alert-body__title__main" }
const _hoisted_9 = { class: "alert-body__title__main__text alert-body__title__text--warning" }
const _hoisted_10 = { class: "alert-body__title__sub" }
const _hoisted_11 = { class: "alert-body__title__sub__text alert-body__title__text--warning" }
const _hoisted_12 = {
  key: 0,
  class: "alert-body__content"
}
const _hoisted_13 = {
  key: 1,
  class: "alert-body__confirm"
}

import { computed, nextTick, onBeforeUnmount, onUpdated, ref, StyleValue, watch } from 'vue';
import { i18n } from '@/i18n';
import { onMounted } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { AlertBasicDataObject } from '@/coreDomainsModule/alert';

/**
 * propsの定義
 * @param alertData - アラート情報のオブジェクトの配列
 */
type AlertProps = {
  alertData: AlertBasicDataObject[];
  propIsOpening: boolean;
  iconWarning?: string;
  iconError?: string;
  isDescriptionAlignCenter?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertCell',
  props: {
    alertData: {},
    propIsOpening: { type: Boolean },
    iconWarning: { default: 'alertCellWarning' },
    iconError: { default: 'alertCellError' },
    isDescriptionAlignCenter: { type: Boolean }
  },
  emits: ["onNext", "click"],
  setup(__props: any, { emit: __emit }) {

/**
 * テーブルアラートモーダル
 */
const props = __props;

const emits = __emit;

const t = i18n.t;

// ランダムID生成
const imgId = ref<string>('');
onMounted(() => {
  imgId.value = Math.random().toString(32).substring(2);
  window.addEventListener('click', onClickBackground);
});

onUpdated(() => {
  if (isOpening.value) {
    const element = document.getElementById(imgId.value + '-modal');
    if (!element) return;
    const elementRect = element.getBoundingClientRect();
    if (elementRect.top < 0) {
      yLength.value = yLength.value + Math.abs(elementRect.top) + 8;
    }
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('click', onClickBackground);
});

const xLength = ref(0);
const yLength = ref(0);
const bubbleHeight = ref(0);
const isOpening = ref(false);
const isHorizontalReverse = ref(true);

/**
 * アラートアイコンを表示するかどうか
 * alertTypesに何か入っているかどうかで判断
 * @param alertData - アラートの種類の配列
 */
const isDisplayAlertIcon = (alertData: AlertBasicDataObject[]) => {
  return alertData.length > 0;
};

const alertIconName = computed((): string => {
  let res = props.iconWarning;
  props.alertData.map((alertDatum) => {
    if (alertDatum.type === 'error') {
      res = props.iconError;
    }
  });
  return res;
});

const alertIconStyle = computed((): StyleValue => {
  if (props.iconWarning !== 'alertCellWarning' || props.iconError !== 'alertCellError') {
    return { padding: '2px' };
  }
  return {};
});

watch(
  () => isOpening.value,
  () => {
    if (isOpening.value) {
      const element = document.getElementById(imgId.value);
      if (!element) return;
      bubbleHeight.value = 0;
      isHorizontalReverse.value = false;
      const iconRect = element.getBoundingClientRect();
      xLength.value = iconRect.left + window.scrollX;
      yLength.value = iconRect.top + window.scrollY;
    }
    emits('click', isOpening.value);
    nextTick(() => {
      const iconRect = document.getElementById(imgId.value)?.getBoundingClientRect();
      const modalRect = document.getElementById(imgId.value + '-modal')?.getBoundingClientRect();
      if (!modalRect || !iconRect) return;
      if (modalRect.left < 0) {
        isHorizontalReverse.value = true;
        xLength.value = iconRect.right + modalRect.width + 8;
      }
      if (modalRect.bottom > window.innerHeight) {
        yLength.value = yLength.value - (modalRect.bottom - window.innerHeight) - 8;
        bubbleHeight.value = modalRect.height / 2 + (modalRect.bottom - window.innerHeight); // 21は吹き出しの高さの半分
      }
    });
  }
);

watch(
  () => props.propIsOpening,
  () => {
    if (isOpening.value && !props.propIsOpening) {
      isOpening.value = false;
    }
  }
);

const getModalStyle = computed((): StyleValue => {
  return {
    top: `${yLength.value}px`,
    left: isHorizontalReverse.value ? `${xLength.value}px` : `${xLength.value - 40}px`, // 40は吹き出しの位置調整
    'grid-template-columns': `repeat(${props.alertData.length}, 1fr)`,
  };
});

const getBubbleStyle = computed(() => {
  return {
    top: bubbleHeight.value ? `${bubbleHeight.value}px` : '50%', // 基本的には50%。モーダルが画面端に来て位置がズレる場合は吹き出しの位置が対象の要素の中心に来るようにする
    left: isHorizontalReverse.value ? '-10px' : 'auto',
    right: !isHorizontalReverse.value ? '-10px' : 'auto',
  };
});

const descriptionStyle = computed((): StyleValue => {
  return { textAlign: props.isDescriptionAlignCenter ? 'center' : 'start' };
});

/**
 * モーダル展開時にバックグラウンドをクリックしたかの判定と処理
 * @param e - イベント
 */
const onClickBackground = (e: MouseEvent) => {
  if (!isOpening.value || !e.target || !(e.target instanceof HTMLElement)) return;
  if (!e.target.closest('.alert-cell__modal')) {
    isOpening.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(SvgLoader, {
      id: imgId.value,
      class: "alert-cell__status-tag",
      style: _normalizeStyle(alertIconStyle.value),
      name: alertIconName.value,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpening.value = !isOpening.value))
    }, null, 8, ["id", "style", "name"]), [
      [_vShow, isDisplayAlertIcon(_ctx.alertData)]
    ]),
    (isOpening.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            id: imgId.value + '-modal',
            class: "alert-cell__modal modal-container",
            style: _normalizeStyle(getModalStyle.value)
          }, [
            _createElementVNode("div", {
              class: "alert-cell__bubble",
              style: _normalizeStyle(getBubbleStyle.value)
            }, null, 4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertData, (alertDatum, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'alert' + index,
                class: "alert-body"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  (alertDatum.type === 'error')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(SvgLoader, {
                            class: "alert-body__title__icon alert-body__title__icon--error",
                            name: "calendarAlert"
                          }),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(alertDatum.title), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(alertDatum.subtitle), 1)
                        ])
                      ], 64))
                    : (alertDatum.type === 'warning')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(SvgLoader, {
                              class: "alert-body__title__icon alert-body__title__icon--warning",
                              name: "warning"
                            }),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(alertDatum.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(alertDatum.subtitle), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "alert-body__label",
                  style: _normalizeStyle(descriptionStyle.value)
                }, _toDisplayString(alertDatum.description), 5),
                (_ctx.$slots[`alertBody-${alertDatum.kind}`])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _renderSlot(_ctx.$slots, `alertBody-${alertDatum.kind}`)
                    ]))
                  : _createCommentVNode("", true),
                (alertDatum.showConfirmButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(TextButton, {
                        size: "btn-sm",
                        onClick: ($event: any) => (emits('onNext', alertDatum.kind))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('確認する')), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 12, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})